import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'feedback-sent',
    templateUrl: './feedback-sent.component.html',
    styleUrls: ['./feedback-sent.component.css'],
    standalone: false
})
export class FeedbackSentComponent {

    constructor(public activeModal: NgbActiveModal) {}

}